import dayjs from 'dayjs'
import {
  volumeLimitAir,
  volumeLimitSe,
  weightLimitAir,
  weightLimitSe,
  singleMaxVolume,
  suggestTips,
  calcHctCai,
  isLongAndThin,
  isSupserLong,
  isLong,
} from '@g/utils/parcelUtils'
import * as storageUtils from '@g/utils/storageUtils'
import parcelExampleList from '../../data/parcelExampleList'
// import { testParcelList } from '../../data/testdata'
import calc from 'calculatorjs'
import localforage from 'localforage'
import { isParcelInDisplayWhs } from '@g/utils/parcelDisplayWhs'
import { findBlockingUnfinishedVaorder } from '@g/utils/parcelVaorder'
import {
  findCategoryAssociationCandidate,
  getCategoryAssociationPlatform,
} from '@g/utils/parcelCategoryAssociation'

/**
 * status 0 在途中 KD
1 已攬收 KD
2 疑難 KD
3 已簽收 KD
4 已拒簽 KD
5 派送中 KD
6 退回 KD
7 轉單 KD
corrwhse 已確認收件倉庫地址正確
signed 倉庫已簽收
stored 已入庫
racked 已上架
migrate 倉庫迁移
picking 撿貨中
packing 打包中
packed 已打包
deleted 已删除
 */

const state = {
  showShippingRate: false,
  shippingRateCurrentTab: 'tab-sr',
  list: [], // 已入库的包裹列表
  unStorageList: [], // 待入库的包裹列表
  serviceType: {
    sses: '快遞面單拍照',
    reinforce: '包裝氣泡棉',
    wrapAcb: '包裝氣柱袋',
    unboxing: '開箱拍照',
    ooba: '開箱驗貨',
    vaPoweronTest: '通電測試',
    stuffing: '填充氣柱袋',
    specialNeed: '其他需求'
  },
  selPclids: [], // 已选中的包裹 id
  selUnStoragePclids: [], // 已选中的未入库包裹 id
  selPclidsByCnorder: [], // 已选中的包裹 id，用于创建转寄订单
  showModels: {}, // h5 已展开的信息

  pcShowSettings: {
    showSnapshots: false,
    showOrderDetail: false,
    ...localStorage.pcShowSettings ? JSON.parse(localStorage.pcShowSettings) : {}
  },
  extrudePclid: 0, // 突出顯示的 包裹
  exampleList: parcelExampleList,
  choseWhsAddrid: '',
  seVipWhsAddrid: '1050',
  seFzWhsAddrid: '1591',
  seaWhsAddrid: '1769',
  airAddrids: ['1024'],
  airTwtAddrids: ['1024'], // 支持特货空运
  airOnlyFoodTwtAddrids: [], // 支持特货空运
  seAddrids: ['1024', '1050', '1210', '1591', '1592', '1596', '3591', '1598', '2591', '2769'],
  seaAddrids: ['1596'],
  notAirWhsAddrids: ['1050', '1210', '1592', '1596', '3591', '2591', '2769', '1598'], // 没有空运
  notAirTwWhsAddrids: [], // 没有空运特货
  hasSeVipParcel: !!localStorage.hasSeVipParcel,
  hasFzParcel: !!localStorage.hasFzParcel,
  freeStoreDayMap: {
    1024: 90,
    2886: 30,
    1210: 180,
    1598: 180,
    1050: 365,
    1769: 30,
    1591: 90,
    1579: 1,
    3591: 365,
    2591: 365,
    2769: 90,
    1592: 180,
    1596: 365,
  },
  freeSmallWeightAddrMap: { // 免费小包裹重量
    1024: 3,
    2886: 3,
    1210: 3,
    1598: 3,
    1050: 3,
    1769: 3,
    1591: 999,
    1592: 999,
    1596: 999,
    3591: 999,
    1579: 3,
    2591: 999,
    2769: 3,
  },
  szWeightMore10Kg: !!localStorage.szWeightMore10Kg,
  hasParcelsAddrids: localStorage.hasParcelsAddrids ? JSON.parse(localStorage.hasParcelsAddrids) : [],
  storageWhsArray: [],

  showKdTrackingData: {
    show: false,
    model: null,
  },
}

const getters = {
  // 配送类型
  renderJySrType: (state, getters) => (addr) => {
    const label = addr && addr.label ? addr.label : addr
    return label
      ? `<span class="px-1 purple lighten-5 deep-purple--text text--darken-4">${label}</span>`
      : ''
  },
  chosedParcels (state) { // 已勾选的包裹
    return state.selPclids.map(pclid => {
      return state.list.find(parcel => pclid === parcel.pclid)
    }).filter(item => item)
    // return state.list.filter(parcel => state.selPclids.includes(parcel.pclid))
  },
  parcelsByCurrAddrid (state, getters, rootState) { // 已勾选的包裹
    return state.list
      .filter(item => isParcelInDisplayWhs(item, state.choseWhsAddrid, rootState.project))
    // return state.list.filter(parcel => state.selPclids.includes(parcel.pclid))
  },
  chosedParcelsByCurrAddrid (state, getters, rootState) { // 已勾选的包裹
    return state.selPclids.map(pclid => {
      return state.list.find(parcel => pclid === parcel.pclid)
    }).filter(item => item)
      .filter(item => isParcelInDisplayWhs(item, state.choseWhsAddrid, rootState.project))
    // return state.list.filter(parcel => state.selPclids.includes(parcel.pclid))
  },
  qiaopingAddrParcelsTotalWeightMap (state, getters) {
    const map = {}
    state.list.forEach(parcel => {
      if (!map[parcel.jyAddrid]) {
        map[parcel.jyAddrid] = 0
      }
      if (
        parcel.hasWooden ||
        parcel.isFood ||
        parcel.isLongAndThin ||
        parcel.isFood ||
        parcel.isSupserLong
      ) {
        return
      }
      map[parcel.jyAddrid] = calc.add(map[parcel.jyAddrid], parcel.weight)
    })

    return map
  },
  chosedParcelsTotalWeight (state, getters) { // 已勾选的包裹
    return getters.chosedParcels.reduce((prev, curr) => {
      if (curr.weight <= 50) {
        return prev
      }
      return calc.add(prev, curr.weight)
    }, 0)
  },
  chosedOverweightParcel (state, getters) { // 选择的超重包裹
    return null
    // return getters.chosedParcels.find(parcel => parcel.weight >= 69500 && !parcel.isSeaWhs)
  },
  chosedParcelOnlyTnoPri (state, getters) { // 只选择了子母单批量件
    return getters.chosedParcelsByCurrAddrid.every(parcel => parcel.extraInfo.tnoPriBatch)
  },
  chosedFreeWeightParcels (state, getters) { // 是否已经达到免计重包裹限制
    return getters.chosedParcelsByCurrAddrid.filter(parcel => parcel.freeWeight)
  },
  chosedFreeWeightParcelLimit (state, getters) { // 是否已经达到免计重包裹限制
    if (getters.chosedFreeWeightParcels.length) {
      return getters.chosedFreeWeightParcels.length >= state.freeSmallWeightAddrMap[getters.chosedFreeWeightParcels[0].jyAddrid]
    }
    return 0
  },
  chosedParcelAddrid (state, getters) { // 已经选择包裹的仓库
    return getters.chosedParcels.length ? getters.chosedParcels[0].jyAddrid : ''
  },
  chosedParcelIsFood (state, getters) { // 选择的包裹是否是食品
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.isFood)
  },
  chosedParcelIsSuperLong (state, getters) { // 选择的包裹是否是食品
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.isSupserLong)
  },
  chosedParcelIsInclTaxOrFreight (state, getters) { // 选择的包裹是否包郵或包稅
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.isInclTaxOrFreight)
  },
  chosedParcelIsMask (state, getters) { // 选择的包裹是否是口罩
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.isMask)
  },
  chosedParcelAllCanSea (state, getters) { // 选择的包裹是否都能海运
    return getters.chosedParcelsByCurrAddrid.length && getters.chosedParcelsByCurrAddrid.every(item => item.canSea)
  },
  chosedParcelOnlyCcMethod91 (state, getters) { // 选择的包裹是否是口罩
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.onlyCcMethod91)
  },
  chosedParcelWeight (state, getters) { // 选择的包裹总重量
    return getters.chosedParcelsByCurrAddrid
      .reduce((prev, curr) => calc.add(curr.weight || 0, prev), 0)
  },
  chosedFoodParcelWeight (state, getters) { // 选择的食品包裹总重量
    return getters.chosedParcelsByCurrAddrid.filter(item => item.isFood)
      .reduce((prev, curr) => calc.add(curr.weight || 0, prev), 0)
  },
  chosedParcelTotalHctCai (state, getters) { // 材数
    return getters.chosedParcelsByCurrAddrid.reduce((prev, curr) => prev + curr.hctCai, 0)
  },
  hasParcelMore20Weight (state, getters) { // 是否有大于 20KG 包裹
    return state.list.filter(parcel => parcel.weight >= 20000).length > 0
  },
  chosedParcelMore20Weight (state, getters) { // 20kg以上的包裹不能下单超过10个
    return getters.chosedParcelsByCurrAddrid.filter(parcel => parcel.weight >= 20000)
  },
  chosedParcelMoreBgCai (state, getters) { // 4才以上的包裹
    return getters.chosedParcelsByCurrAddrid.filter(parcel => parcel.hctCai >= 4)
  },
  hasParcelLongAndThin (state, getters) { // 是否是细长包裹
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.isLongAndThin)
  },
  hasParcelIsRrapidTestKits (state, getters) { // 是否試劑
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.isRrapidTestKits)
  },
  hasParcelSmallPack (state, getters) { // 是否是小包裹
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.smallPack)
  },
  hasParcelHasWooden (state, getters) { // 是否有木架包裹
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.hasWooden)
  },
  hasParcelCanFragile (state, getters) { // 是否有木架包裹
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.canFragile)
  },
  onlyHasParcelLong (state, getters) { // 是否是细长包裹
    return getters.chosedParcelsByCurrAddrid.length && !getters.chosedParcelsByCurrAddrid.find(item => !item.isLong)
  },
  onlyHasFzParcel (state, getters) { // 只有福州的包裹
    return state.list.filter(parcel => !parcel.isFzWhs).length === 0
  },
  onlyHasHgParcel (state, getters) { // 只有海關監管倉的包裹
    return state.list.filter(parcel => !parcel.isSeVipWhs).length === 0
  },
  chosedParcelHasDg1688 (state, getters) { // 选择的包裹是否是1688代购
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.extraInfo.srcPlatform === 'DG1688')
  },
  chosedParcelHasDgtb (state, getters) { // 选择的包裹是否是淘宝代购
    return !!getters.chosedParcelsByCurrAddrid.find(item => item.extraInfo.hasItemDgtaobao)
  },
}

const mutations = {
  setShowKdTrackingData (state, data) {
    state.showKdTrackingData = data
  },
  setList (state, data) {
    state.list = data
    state.hasParcelsAddrids = Array.from(new Set(data.map(item => item.jyAddrid)))
    localStorage.hasParcelsAddrids = JSON.stringify(state.hasParcelsAddrids)
    localforage.setItem('parcelList', data.slice(0, 3))
    // localStorage.parcelList = JSON.stringify(data)
  },
  setUnStorageList (state, data) {
    state.unStorageList = data
  },
  setShowShippingRate (state, data) {
    state.showShippingRate = data
  },
  setSzWeightMore10Kg (state, data) {
    localStorage.szWeightMore10Kg = '1'
    state.szWeightMore10Kg = data
  },
  setExtrudePclid (state, data) {
    state.extrudePclid = data
  },
  setShippingRateCurrentTab (state, data) {
    state.shippingRateCurrentTab = data
  },
  setSelPclids (state, data) {
    state.selPclids = data
  },
  setSelUnStoragePclids (state, data) {
    state.selUnStoragePclids = data
  },
  setSelPclidsByCnorder (state, data) {
    state.selPclidsByCnorder = data
  },
  setShowModels (state, data) {
    state.showModels = data
  },
  setPcShowSettings (state, data) {
    state.pcShowSettings = data
    localStorage.pcShowSettings = JSON.stringify(data)
  },
  setHasSeVipParcel (state, data) {
    if (data) {
      localStorage.hasSeVipParcel = '1'
    } else {
      localStorage.removeItem('hasSeVipParcel')
    }
    state.hasSeVipParcel = data
  },
  setHasFzParcel (state, data) {
    if (data) {
      localStorage.hasFzParcel = '1'
    } else {
      localStorage.removeItem('hasFzParcel')
    }
    state.hasFzParcel = data
  },
  setChoseWhsAddrid (state, data) {
    state.choseWhsAddrid = data
  },
  setStorageWhsArray (state, data) {
    state.storageWhsArray = data
  },
}

const actions = {
  formatParcelList ({ state, commit, rootState }, sourceList) {
    // 超过24小时
    const tipsTime = Date.now() - 1000 * 60 * 60 * 10
    let list = []
    try {
      list = sourceList.map(item => {
        if (typeof item.extraInfo === 'string') {
          item.extraInfo = JSON.parse(item.extraInfo)
        }
        if (!item.extraInfo.tpTaobaoTradeItems) {
          item.extraInfo.tpTaobaoTradeItems = []
        } else if (typeof item.extraInfo.tpTaobaoTradeItems === 'object' && !Array.isArray(item.extraInfo.tpTaobaoTradeItems)) {
          item.extraInfo.tpTaobaoTradeItems = [item.extraInfo.tpTaobaoTradeItems]
        }
        // if (item.trackingNo === '300674243424') {
        //   item.extraInfo.hasRawWood = 1
        // }
        const isStorage = item.jyStorageAt !== '0000-00-00 00:00:00'
        const isTwt = !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemSrType === 'twt')
        // 能否空运
        // const canAir = !item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemEmbargoAir === '1')

        // 能否海快
        // const canSe = !item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemEmbargoSe === '1')
        const canFragile = Boolean(item.extraInfo.hasLgFragile)
        const canSe = item.extraInfo.canTransportSe === 1
        const canSea = canFragile || (state.seaAddrids.includes(item.jyAddrid) && (item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemMold.indexOf('4') > -1 || tpItem.itemMold.indexOf('6') > -1) !== undefined))
        if (canFragile) {
          item.extraInfo.hasRawWood = 0
        }

        const nameList = []
        let fullName = item.extraInfo.isAllCcName === 1
        // if (item.jyAddrid === '1024' || item.jyAddrid === '1210') {
        //   item.extraInfo.tpTaobaoTradeItems.forEach((tpItem) => {
        //     const names = '香水、口罩、木製品、口紅、洗髮水、乳液、護髮素'.split('、')
        //     if (names.includes(tpItem.itemCcName) || names.includes(tpItem.itemHsName) || names.includes(tpItem.itemTwName)) {
        //       tpItem.itemCcMaxBox = '0'
        //       tpItem.itemShptBrief = '由於平潭海關1/10至1/14嚴查香水、口罩、木製品、口紅、洗髮水、乳液、護髮素，為避免查扣延誤時效，在此期間不能打包回臺'
        //     }
        //   })
        // }
        item.extraInfo.tpTaobaoTradeItems.forEach((tpItem) => {
          const names = ['顯示屏', '電視'] // 提醒打木箱
          if (
            (names.includes(tpItem.itemCcName) || names.includes(tpItem.itemHsName) || names.includes(tpItem.itemTwName)) &&
            item.width > 0
          ) {
            item.extraInfo.tipWoodenBox = '1'
          }
          if (tpItem.itemTag === 'QIMEN') {
            tpItem.itemBrief = ''
          }

          // 是否反倾销税  isADTAX
          // 是否貨物稅  isLRTT
          // 是否商检貨 C02  isIRC02
          // tpItem.反傾銷稅 = tpItem.catTrfAntiDumpingTax === '1'
          // tpItem.貨物稅 = tpItem.catTrfLevyRule && tpItem.catTrfLevyRule.indexOf('T') > -1
          // tpItem.商檢 = tpItem.catTrfImportRule && tpItem.catTrfImportRule.indexOf('C02') > -1
        })

        item.extraInfo.tpTaobaoTradeItems.forEach((tpItem) => {
          if (tpItem.itemMold !== '0' && tpItem.traPlatform !== 'xianyu' && !tpItem.itemCcName) {
          // fullName = false
          }
          if (tpItem.itemMold !== '0' && // 0 是虛擬
          tpItem.itemTwName &&
          !nameList.find(item2 => item2.itemTwName === tpItem.itemTwName && item2.itemShptBrief === tpItem.itemShptBrief)
          ) {
            nameList.push({
              ...tpItem,
            })
          }
          if (tpItem.itemBrief === 'mock') {
            tpItem.itemName = `手動登記 ${tpItem.itemTwName}`
          }
        })

        const lengthArr = [item.length / 10, item.width / 10, item.height / 10]
        lengthArr.sort((a, b) => b - a)

        item.extraInfo.nameList = nameList.map((tpItem) => {
          const itemTwName = storageUtils.get(`${item.pclid}-${tpItem.tiid}`) || tpItem.itemTwName
          return {
            ...tpItem,
            itemTwName,
          }
        })
        item.extraInfo.tpTaobaoTradeItemsHasShpBreief = item.extraInfo.tpTaobaoTradeItems.filter(item => item.itemShptBrief)
        item.extraInfo.fullNames = fullName ? item.extraInfo.nameList.map(item => item.itemTwName).join(',') : ''
        const isMold = !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemMold !== '0')
        const isFood = !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemMold === '2')
        const isFurniture = !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemMold && tpItem.itemMold.indexOf('4') > -1)
        const isMold6x = !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemMold && tpItem.itemMold.indexOf('6') > -1)
        const isFragile = !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemMold && tpItem.itemMold.indexOf('5') > -1) && lengthArr[0] >= 50
        const isLiquid = !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemMold === '3')
        const liquidOverweight = item.weight / item.extraInfo.tpTaobaoTradeItems.filter(tpItem => tpItem.itemMold === '3').reduce((total, tpItem) => {
          return calc.add(total, tpItem.itemQtyAvg || tpItem.itemQty)
        }, 0) > 6000
        // const isMask = !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemCcName && tpItem.itemCcName.indexOf('口罩') > -1)
        const isMask = false
        // 所有商品都為虚拟或闲鱼
        // item.extraInfo.virtualItem = item.extraInfo.isAllUnclear === 1
        item.extraInfo.virtualItem = item.extraInfo.tpTaobaoTradeItems.every(tpItem => tpItem.itemMold === '0')
        item.extraInfo.isQimen = item.extraInfo.tpTaobaoTradeItems.length && item.extraInfo.tpTaobaoTradeItems.every(tpItem => tpItem.itemTag === 'QIMEN') && state.seaAddrids.includes(item.jyAddrid)
        // if (item.trackingNo === '300674243424') {
        //   item.extraInfo.virtualItem = true
        //   item.extraInfo.isQimen = true
        // }

        // 将有问答的商品放在第一个
        const cataIndex = item.extraInfo.tpTaobaoTradeItems.findIndex(item => item.itemCcName && item.catalogQas && item.catalogQas.length)
        let hasQa = false
        if (cataIndex !== -1) {
          const items = item.extraInfo.tpTaobaoTradeItems.splice(cataIndex, 1)
          item.extraInfo.tpTaobaoTradeItems.splice(0, 0, items[0])
          hasQa = true
        }
        item.extraInfo.hasQa = hasQa
        item.extraInfo.showTpItemIndex = 0

        // 只能寄空运，但是所在仓库不支持空运
        const needAirButNoSupport = (!state.airAddrids.includes(item.jyAddrid) || (isTwt && !state.airTwtAddrids.includes(item.jyAddrid))) && (item.extraInfo.canTransportAir === 1 && !canSe && !canSea)

        let canAir = item.extraInfo.canTransportAir === 1 && state.airAddrids.includes(item.jyAddrid)
        if (isTwt && !state.airTwtAddrids.includes(item.jyAddrid)) {
          canAir = false
        }
        // 不是食物，但是仓库只能寄食物
        if (!isFood && state.airOnlyFoodTwtAddrids.includes(item.jyAddrid)) {
          canAir = false
        }

        const unDoVaorder = isStorage && findBlockingUnfinishedVaorder(item.vaorders)
        const hasPackFood = false
        if ((canAir || canSe || canSea) && item.extraInfo.canTransport === 0) {
          // ParcelCanTransport0
          fullName = false
        }
        let canPack = !item.pclError && fullName && (canAir || canSe || canSea) && !item.extraInfo.hasQa
        let enabledChose = isStorage && canPack && !needAirButNoSupport && !unDoVaorder
        if (isFood && item.weight > 6000) {
          enabledChose = false
        }
        if (isLiquid && liquidOverweight) {
          enabledChose = false
        }
        if (item.extraInfo.hasRawWood > 0 && String(item.ippc) === '0') {
          enabledChose = false
        }

        if (item.extraInfo.srcPlatform === 'DG1688' || item.extraInfo.hasItemDgtaobao) {
          // console.log('DG1688', item.jyAddrid, item.trackingNo)
          item.extraInfo.isDgParcel = true
        }

        const isStagnate = false // 每年11/13-11/20 入庫三個月以上的
        let downDay = 30 // 剩余存倉天數
        if (isStorage) {
          let storeDay = state.freeStoreDayMap[item.jyAddrid] || 90
          if (item.trackingNoPri && ['1024'].includes(item.jyAddrid)) {
            storeDay = 365
          }
          const jyStorageAt = dayjs(item.jyStorageAt)
          const jyStorageTime = jyStorageAt.valueOf()
          if (jyStorageTime < 1702224000000) { // 2023-12-11
            if (item.jyAddrid === '2769') {
              storeDay = 180
            }
            if (item.jyAddrid === '1592') {
              storeDay = 90
            }
          }
          if (jyStorageTime < 1701360000000) { // 2023-12-01
            if (item.jyAddrid === '1210' || item.jyAddrid === '1598' || item.jyAddrid === '2769') {
              storeDay = 365
            }
          }
          if (item.extraInfo.storageMaxDays > 0) {
            // 储存天数
            storeDay = Number(item.extraInfo.storageMaxDays)
          }
          // if (item.jyAddrid === '1591' && jyStorageTime < 1677600000000) { // < 2023-03-01
          //   storeDay = 365
          // }
          // if (item.extraInfo.isGotoPacked > 0) {
          //   storeDay = 3
          // }
          // 上海和深圳的子母單，免費倉庫時間寫365天開始倒計時。
          // const storeDay = state.freeStoreDayMap[item.jyAddrid]
          let stagnateDay = dayjs().diff(jyStorageAt, 'day', true)
          if (stagnateDay < 0) {
            stagnateDay = Math.floor(stagnateDay)
          } else {
            stagnateDay = Math.ceil(stagnateDay)
          }
          downDay = storeDay - stagnateDay
          item.extraInfo.stagnateDay = stagnateDay
          // if (item.jyAddrid === '3591' && item.trackingNoPri) {
          //   downDay = 9999
          // }
        }

        let lost = false // 快递没有被仓库签收，可能是送错地方
        if (String(item.status) === '3') {
          const statusAt = dayjs(item.statusAt)
          if (statusAt.get('hour') >= 18) { // 18 点后
            const curr = dayjs()
            if (statusAt.diff(curr, 'day') === 0) { // 当天
            } else if (statusAt.diff(dayjs(), 'day') < -1) { // 超过一天
              lost = true
            } else if (curr.get('hour') >= 12) { // 隔天 12 点后
              lost = true
            }
          } else { // 18 前
            lost = true
          }
        }

        const isItemDualUse = item.extraInfo.tpTaobaoTradeItems.some((tpItem) => {
          // const keys = ['稀土永磁']
          // return keys.some(key => tpItem.itemName?.indexOf(key) > -1)
          return tpItem.isDualUse > 0
        })
        if (isItemDualUse) {
          item.extraInfo.isItemDualUse = true
          enabledChose = false
          canPack = false
        }

        const isSeaWhs = isStorage && item.jyAddrid === state.seaWhsAddrid // 在海快商务仓
        const isSeVipWhs = isStorage && item.jyAddrid === state.seVipWhsAddrid // 在海快商务仓
        const isFzWhs = isStorage && item.jyAddrid === state.seFzWhsAddrid // 在海快商务仓
        // let isSeVipWhs = false // 在海快商务仓
        if (isSeVipWhs) {
          commit('setHasSeVipParcel', true)
        }
        if (isFzWhs) {
          commit('setHasFzParcel', true)
        }

        let hasOpt = false // 有需要客人操作的內容
        if (!item.extraInfo.tpTaobaoTradeItems.length ||
          item.extraInfo.virtualItem) {
          hasOpt = true
        }
        if (!item.extraInfo.virtualItem && item.extraInfo.hasQa) {
          hasOpt = true
        }
        // if (item.trackingNo === '773054072074625') {
        //   item.extraInfo.isAllCcName = 0
        //   item.extraInfo.virtualItem = true
        //   item.extraInfo.tpTaobaoTradeItems.forEach(item => {
        //     item.traPlatform = '1688'
        //     item.itemCcName = ''
        //   })
        // }
        item.extraInfo.tpTaobaoTradeItems.forEach(tpItem => {
          const execR = /\[(.+)\]$/.exec(tpItem.itemName)
          // console.log(tpItem.itemName, execR)
          if (execR) {
            tpItem.itemName = tpItem.itemName.replace(execR[0], '')
            tpItem.catPlatform = execR[1].toLowerCase()
            if (tpItem.catPlatform === '1688') {
              tpItem.traPlatform = '1688'
            }
            if (tpItem.catPlatform === 'pinduoduo') {
              tpItem.traPlatform = 'pinduoduo'
            }
          } else {
            // if (tpItem.traPlatform === '1688tb' && tpItem.catPlatform !== 'taobao') {
            //   tpItem.catPlatform = '1688'
            // }
            // if (tpItem.traPlatform === 'pddtb' && tpItem.catPlatform !== 'taobao') {
            //   tpItem.catPlatform = 'pinduoduo'
            // }
          }
          // tpItem.traPlatform = tpItem.catPlatform || tpItem.traPlatform
        })
        let updateCidByPlatForm = '' // 需要绑定淘宝cid
        const allowCategoryAssociation = !item.extraInfo.hasQa && (!fullName || item.extraInfo.virtualItem)
        const needUpdateCidTpItem = findCategoryAssociationCandidate(
          item.extraInfo.tpTaobaoTradeItems,
          allowCategoryAssociation
        )
        if (needUpdateCidTpItem) {
          hasOpt = true
          needUpdateCidTpItem.needUpdateCid = true
          updateCidByPlatForm = getCategoryAssociationPlatform(needUpdateCidTpItem)
          item.extraInfo.tpTaobaoTradeItems = [
            needUpdateCidTpItem,
            ...item.extraInfo.tpTaobaoTradeItems.filter(tpItem => tpItem !== needUpdateCidTpItem)
          ]
        }

        const freeWeight = isStorage && item.weight <= 50
        const freeWeightTbdg = isStorage && item.weight <= 1000 && item.extraInfo.hasItemDgtaobao && dayjs(item.jyStorageAt) < dayjs('2024-10-21')

        item.hctCai = calc.round(calcHctCai(item, false), 2)
        // item.hctCai = 2

        // item.etaAt = '2025-03-01 16:59:59'
        let etaAtText = ''
        if (!isStorage && item.etaAt) {
          const etaAt = dayjs(item.etaAt)
          const diffDay = etaAt.dayOfYear() - dayjs().dayOfYear()
          if (diffDay > 1) {
            etaAtText = etaAt.format('預計M.D送達')
          } else if (diffDay === 1) {
            etaAtText = etaAt.format('預計明天送達')
          } else if (diffDay === 0) {
            item.extraInfo.sameDay = true
            etaAtText = etaAt.format('預計今天送達')
            const diffHour = etaAt.get('hour')
            if (diffHour > 0) {
              // 預計上午送達（0-11點）
              // 預計中午送達（11-13點）
              // 預計下午送達（13-18點）
              // 預計晚上送達（18-22點）
              if (etaAt.get('hour') <= 11) {
                etaAtText = etaAt.format('預計上午送達')
              } else if (etaAt.get('hour') <= 13) {
                etaAtText = etaAt.format('預計中午送達')
              } else if (etaAt.get('hour') <= 18) {
                etaAtText = etaAt.format('預計下午送達')
              } else if (etaAt.get('hour') <= 22) {
                etaAtText = etaAt.format('預計晚上送達')
              }
            }
          }
        }

        let giftType = ''
        if (item.trackingNo.indexOf('GIFTKNIFE') > -1) {
          giftType = 'GIFTKNIFE'
          item.extraInfo.tpTaobaoTradeItems = item.extraInfo.giftknife || []
        }
        if (item.trackingNo.indexOf('GIFTMK') > -1) {
          giftType = 'GIFTMK'
          item.extraInfo.tpTaobaoTradeItems = item.extraInfo.giftitems || []
          item.carrier = ''
          item.carrierName = ''
        }

        if (giftType) {
          enabledChose = true
          canPack = true
        }
        const isSplice = item.splice && (item.splice.spliStatus === '30' || item.splice.spliStatus === '20' || item.splice.spliStatus === '10')

        // 1.包裹状态正常 2，有剩余仓储天数（正数）3.入库时间超过6个月
        // if (item.extraInfo.stagnateDay > 180 && !isSplice && !giftType && downDay >= 0 && !item.pclError) {
        //   const now = dayjs()

        //   //  11月1日-12月31日  以下包裹存放超過3個月，在繁盛期無法進行打包，請於明年1月1日以後下單！
        //   if (now.get('month') >= 11) {
        //     isStagnate = true
        //     enabledChose = false
        //     item.extraInfo.stagnateData = {
        //       day: item.extraInfo.stagnateDay,
        //       lock: false,
        //     }
        //   }
        // }

        const hasWooden = ['woodenSpt', 'woodenBox', 'woodenSptCov'].find(val => item[val] !== '0') || item.extraInfo.hasRawWood > 0 || item.extraInfo.hasWoodSpt > 0 || item.extraInfo.hasWoodBox > 0
        const isRrapidTestKits = !!item.extraInfo.nameList.find(tpItem => tpItem.itemCcName === '新冠病毒檢驗試劑' || tpItem.itemCcName === '新冠快篩')
        const isMock = item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemBrief === 'mock') // 手動登記
        const isCanIncTax = item.extraInfo.nameList.find(tpItem => tpItem.itemCcMethod === '0') &&
                            item.extraInfo.nameList.find(tpItem => tpItem.itemInclTaxMaxWt === '999999')
        const isCanSplice = enabledChose && !isMock && !giftType && item.weight < 5000 && item.hctCai < 6 && !hasWooden && isCanIncTax

        const isCanCreateSplicegroup = enabledChose && item.hctCai < 6 && item.weight < 40000 && !hasWooden && item.tnoPriCount < 5 && item.carrier !== 'kkren' &&
                                        item.extraInfo.nameList.find(tpItem => tpItem.itemCcMethod === '0') &&
                                        item.extraInfo.nameList.find(tpItem => Number(tpItem.itemInclTaxMaxWt) > item.weight)

        const isCanJoinSplicegroup = enabledChose && !isMock && !giftType && item.weight < 5000 && item.hctCai < 6 && !hasWooden && isCanIncTax && item.tnoPriCount < 5 && item.carrier !== 'kkren'

        const onlyCcMethod91 = (!!item.extraInfo.nameList.find(tpItem => tpItem.itemCcMethod === '91') || item.weight > 65000) && !canSea
        // 是否是高压气瓶
        const isHighPressure = !!item.extraInfo.nameList.find(tpItem => tpItem.itemShptBrief && tpItem.itemShptBrief.indexOf('氣罐') > -1)
        // 幸运6 包裹
        const isLucky6 = (item.extraInfo.hasItemDgtaobao && !item.trackingNoPri && item.trackingNo.substr(-1) === '6')
        // || item.trackingNo === '75351615601946'

        let statusBrief = item.statusBrief
        if (statusBrief === '包裹正在等待揽收') {
          statusBrief = '包裹正在等待賣家發貨'
        }

        if (item.jyAddrid === '1210') {
          enabledChose = false
        }
        if (item.extraInfo.whseSuspendAt && !item.extraInfo.whseUnsuspendAt) {
          // 挂失 未找回
          enabledChose = false
        }
        // if (item.extraInfo.isBlindBox === '1') {
        //   // 盲盒
        //   enabledChose = false
        //   item.extraInfo.errorMsg = '雙十二高峰期間盲盒集中存儲暫不能發貨，預計1/1前恢復'
        // }

        // 廈門倉限制有體積的傢具不能下單海快
        if (isFurniture && item.jyAddrid === '1592' && item.hctCai >= 3) {
          enabledChose = false
          item.extraInfo.errorMsg = '因近期海關政策變化，家具無法透過台中關進口，請轉寄至漳州倉走海運家具或海快傢具專線'
        }
        if (item.extraInfo.srcAttributes?.solutionCode === 'QIAOQIAOLANG_TW_TRANSIT_OCEAN') {
          // 在1688那边集运，不能在巧巧郎集运
          enabledChose = false
        }
        // if (item.status === 'stored' && item.jyAddrid === '1596' && item.extraInfo.jyAddridFwd === 'zzhou') {
        //   // 義烏倉轉運中的包裹要先鎖起來不讓下單
        //   enabledChose = false
        // }

        // 1688代购 或 盲盒 不处理
        // if (isStorage && item.extraInfo.srcPlatform !== 'DG1688' && item.extraInfo.isBlindBox !== '1') {
        //   const needImportSellerInfoTpItem = item.extraInfo.tpTaobaoTradeItems.find(tpItem => {
        //   // if (rootState.userData.uid !== '1000' && rootState.userData.uid !== '104038') {
        //   //   return false
        //   // }
        //     // if (tpItem.sellerUSCI && rootState.isPord) {
        //     if (tpItem.sellerUSCI) {
        //       return false
        //     }
        //     if (String(tpItem.sellerStatus) === '404' || tpItem.sellerStatus === 'TODO ') {
        //       return false
        //     }
        //     if (tpItem.traPlatform === '99api' || tpItem.traPlatform === 'api99' || tpItem.itemBrief === 'mock') {
        //       return false
        //     }
        //     if (tpItem.traPlatform === 'pinduoduo' || tpItem.traPlatform === 'pddtb') {
        //       if (window.isPc) {
        //       // PC 拼多多先不处理
        //         return false
        //       }
        //     }
        //     if (tpItem.traPlatform === '1688' || tpItem.traPlatform === '1688tb') {
        //       // 1688 先不处理
        //       return false
        //     }
        //     // traSellerId 值为  「空 mock PDDAPI QIMEN」不去获取卖家公司
        //     if (!tpItem.traSellerId || tpItem.traSellerId === 'mock' || tpItem.traSellerId === 'PDDAPI' || tpItem.traSellerId === 'QIMEN') {
        //       return false
        //     }
        //     return true
        //   })
        //   item.extraInfo.needImportSellerInfoTpItem = needImportSellerInfoTpItem
        // }

        // 批量包裹， 子母单 >= 5 件
        item.extraInfo.tnoPriBatch = item.tnoPriCount >= 5

        if (item.extraInfo.srcPlatform === 'PDDAPI') {
          // console.log('DG1688', item.jyAddrid, item.trackingNo)
          item.jyAddrid = '50001'
          enabledChose = false
        }
        return {
          ...item,
          statusBrief,
          unDoVaorder,
          lost,
          isStorage,
          enabledChose,
          canPack,
          showInputDescTips: isStorage && !item.extraInfo.hasQa && !item.extraInfo.virtualItem && !fullName && dayjs(item.jyStorageAt).valueOf() < tipsTime,
          exceedVolumeLimitAir: volumeLimitAir(item),
          exceedVolumeLimitSe: volumeLimitSe(item),
          exceedWeightLimitAir: weightLimitAir(item),
          exceedWeightLimitSe: weightLimitSe(item),
          singleMaxVolume: !isSeaWhs ? singleMaxVolume(item) : '',
          suggestTips: !isSeaWhs ? suggestTips(item) : '',
          isLongAndThin: isLongAndThin(item),
          isLong: isLong(item),
          isSupserLong: isSupserLong(item),
          updateCidByPlatForm,
          isInclTaxOrFreight: item.extraInfo.ptytInclFreight === 'Y' || item.extraInfo.ptytInclTax === 'Y',
          // 非实物包裹，需要提示登记其他商品，只要有一个是实物
          isMold,
          isFood, // 食品
          isFragile, // 易碎
          isFurniture, // 家具
          isMold6x, // 1-6类，海运杂货
          isLiquid,
          isHighPressure,
          liquidOverweight,
          needAirButNoSupport,
          hasPackFood,
          isSeVipWhs,
          isFzWhs,
          isSeaWhs,
          isLucky6,
          // 是否包含特货
          isTwt,
          hasXianyu: !!item.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.traPlatform === 'xianyu'),
          canAir,
          canSe,
          canSea,
          canFragile,
          chosed: state.selPclids.indexOf(item.pclid) !== -1,
          premiumFeeTemp: Number(item.premiumFee),
          showEditPremiumFee: false,
          downDay,
          hasOpt,
          freeWeight,
          freeWeightTbdg,
          etaAtText,
          giftType,
          isMask,
          isRrapidTestKits,
          isPTYTKITS: item.trackingNo.indexOf('PTYTKITS') > -1,
          // 有木架加固类服務
          hasWooden,
          // 没有体积的小包裹
          // smallPack: !hasWooden && item.width === '0',
          // 4才以下小包裹
          smallPack: !hasWooden && item.hctCai < 4,
          isMock,
          isSplice,
          isCanIncTax,
          isCanSplice,
          isCanCreateSplicegroup,
          isCanJoinSplicegroup,
          onlyCcMethod91,
          isStagnate,
          lengthArr,
        }
      })
      list.forEach(item => {
        item.extraInfo.nameList.forEach(nameItem => {
          // A 禁止進口  level 3
          // 不允許勾選打包
          // 紅色 顯示 限制原因
          // B 限制數量<10箱 或者任意件數 and 已入庫的同一品名存在多件時  level 2
          // 黃色顯示 限制原因
          // C 限制數量=10箱 and 已入庫的同一品名存在多件時 level 1
          // 黑色顯示 限制原因
          //  level 0  無限制
          let limitLevel = 0

          if (nameItem.itemCcMaxBox !== '999' || nameItem.itemCcMaxQty !== '999999' || nameItem.itemCcMaxWt !== '999999' || nameItem.itemInclTaxMaxWt !== '999999') {
            let qty = 0
            list.forEach(item2 => {
              item2.extraInfo.tpTaobaoTradeItems.forEach(tpItem => {
                if (tpItem.itemCcName === nameItem.itemCcName) {
                  qty += Number(tpItem.itemQty)
                }
              })
            })

            if (nameItem.itemCcMaxBox === '0' || nameItem.itemCcMaxQty === '0' || nameItem.itemCcMaxWt === '0' || (Number(nameItem.itemCcMaxWt) <= Number(item.weight) && nameItem.itemCcMaxWt !== '999999')) {
              limitLevel = 3
              item.enabledChose = false
            } else if ((nameItem.itemCcMaxQty < 10 || nameItem.itemCcMaxBox !== '999') && qty > 1) {
              limitLevel = 2
            } else if (nameItem.itemCcMaxQty === '10' && qty > 1) {
              limitLevel = 1
            } else if (nameItem.itemInclTaxMaxWt !== '999999' && nameItem.itemInclTaxMaxWt < item.weight) {
              limitLevel = 1
            }
          }
          nameItem.limitLevel = limitLevel
        })
      })

      list.forEach(item => {
        if (item.jyAddrid === '1024' && item.weight > 1000) {
          commit('setSzWeightMore10Kg', true)
        } else if (item.jyAddrid === '1591') {
          commit('setSzWeightMore10Kg', true)
        }
        if (item.extraInfo.needImportSellerInfoTpItem) {
          item.sort = -10 // 需要导入卖家信息置頂
        } else if (item.splice && item.splice.spliid) {
          item.sort = -2
        } else if (item.downDay <= 0) {
          item.sort = 0
        } else if (item.hasOpt) {
          item.sort = 10
        } else if (item.extraInfo.isGotoPacked > 0) {
          item.sort = 20
        } else {
          item.sort = 100
        }
        if (item.extraInfo.stagnateData) { // 滯留包裹排在最後
          item.sort = 200
        }
      })
      list.sort((a, b) => a.sort - b.sort)
    } catch (e) {
      console.log(e)
    }
    return list.filter(item => {
      // if (item.createdUid === '1' && !item.isStorage && !item.extraInfo.tpTaobaoTradeItems.length) {
      //   return false
      // }
      // if (item.pclError === 'splicegroup_join') {
      //   return false
      // }
      return true
    })
  },
  fetchDashboardList ({ state, dispatch, commit, rootState }, params) {
    return dispatch('index', params).then(async (res) => {
      const list = await dispatch('formatParcelList', res.data.list || [])
      commit('setList', list)
    })
  },
  getParcelListForCache () {
    return localforage.getItem('parcelList')
  },
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/parcel/index', {
      params,
      noShowError: true
    })
  },
  parcelCrossborderAli ({ state, commit, dispatch, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/parcel-crossborder-1688/search-userid', {
      params,
      noShowError: true
    }).then(res => {
      return dispatch('formatParcelList', res.data.list || [])
    })
  },
  async fetchAllParcel ({ commit, rootState }, params) {
    const list = []
    for (let i = 0; i < (params.filter === 'isStorage' ? 100 : 1); i++) {
      const res = await rootState.axios.get('/jyb/v1frontend/parcel/index', {
        params: {
          ...params,
          page: i + 1,
          pageSize: 500,
        },
        noShowError: true
      })
      if (params.filter === 'isStorage') {
        commit('setStorageWhsArray', res.data.listInfo?.groupUserWarehouse || [])
      }
      if (res.data.list && res.data.list.length) {
        list.push(...res.data.list)
      }
      if (res.data.list.length < 500) {
        break
      }
    }
    return list
  },
  /* prepare ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/parcel/prepare', {params: params})
  }, */
  prepareCarrier ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/parcel/prepare-carrier', { params })
  },
  searchCarrier ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/parcel/search-carrier', { params })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/create', params)
  },
  transfer ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/transfer', params)
  },
  batchCreate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/batch-create', params, {
      timeout: 60000,
    })
  },
  view ({ state, commit, rootState }, params) {
    if (params.pclid?.indexOf('eg') > -1) {
      return Promise.resolve({
        data: {
          model: parcelExampleList.find(item => item.pclid === params.pclid)
        }
      })
    }
    return rootState.axios.get('/jyb/v1frontend/parcel/view', { params })
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/update', params)
  },
  updateCorrwhse ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/update-corrwhse', params)
  },
  clearError ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/clear-error', params)
  },
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/delete', params)
  },
  // 可能属于用户的包裹
  probableConsignee ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/parcel/probable-consignee', { params })
  },
  kdTracking ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/parcel/kd-tracking', { params })
  },
  updatePclError ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/update-pcl-error', params)
  },
  updatePclErrorReturn ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/update-pcl-error-return', params)
  },
  updatePclErrorReject ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/update-pcl-error-reject', params)
  },
  updateRel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/update-rel', params)
  },
  updatePclErrorDonate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/update-pcl-error-donate', params)
  },
  batchUpdateItemmold6Todo ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/parcel/batch-update-itemmold6-todo', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
